import axios from 'api';

// /api/super/feature-flags/ — thin wrapper over SystemSetting with `feature.` prefix.
// `value` is JSON: bool / number / string / list / object.

export const getFeaturesPageData = ({ search, pageSize, pageIndex }) => {
  const params = new URLSearchParams();
  if (pageSize != null) params.set('page_size', pageSize);
  if (pageIndex != null) params.set('page', pageIndex);
  if (search) params.set('search', search);
  return axios.get(`/api/super/feature-flags/?${params.toString()}`);
};

export const getAllPages = () => {
  return axios.get(`/api/super/feature-flags/?page_size=1000`);
};

// Create — `feature.` prefix is auto-added by the backend if missing.
export const createFeatureFlag = (params) => {
  return axios.post(`/api/super/feature-flags/`, params);
};

// Update by key (URL-encoded — keys carry the `feature.` prefix).
export const updateFeaturePage = (params) => {
  const { key, ...body } = params;
  return axios.patch(`/api/super/feature-flags/${encodeURIComponent(key)}/`, body);
};

export const deleteFeatureFlag = (key) => {
  return axios.delete(`/api/super/feature-flags/${encodeURIComponent(key)}/`);
};

export const invalidateFeatureFlagCache = (key) => {
  return axios.post(`/api/super/feature-flags/${encodeURIComponent(key)}/invalidate-cache/`);
};

// ─── Legacy stubs ────────────────────────────────────────────────────────
import { removedStub } from 'api/_legacy';
export const getAllRolesData = removedStub('getAllRolesData');
export const getPageComponentData = removedStub('getPageComponentData');
export const updatePageComponent = removedStub('updatePageComponent');
export const getComponentFeaturesData = removedStub('getComponentFeaturesData');
export const getAllPageComponents = removedStub('getAllPageComponents');
export const getAllPageComponentsByPageId = removedStub('getAllPageComponentsByPageId');
export const updateComponentFeature = removedStub('updateComponentFeature');
export const createComponentFeature = removedStub('createComponentFeature');
export const deleteComponentFeature = removedStub('deleteComponentFeature');
